import React, { Component } from "react";
import { createPortal } from "react-dom";

class Portfolio extends Component {
  state = {
    openProject: null,
    lightboxImage: null,
    playingVideo: null,
  };

  workBodies = [];
  videoPlayers = [];
  portfolioRef = React.createRef();
  portfolioScrollTop = 0;

  toggleProject = (index) => {
    this.setState((prevState) => ({
      openProject: prevState.openProject === index ? null : index,
    }));
  };

  openLightbox = (imageSrc) => {
    const portfolio = this.portfolioRef.current;

    if (portfolio) {
      this.portfolioScrollTop = portfolio.scrollTop;
      portfolio.style.overflow = "hidden";
    }

    this.setState({ lightboxImage: imageSrc });

    document.body.style.overflow = "hidden";
    document.body.classList.add("lightbox-open");
  };

  closeLightbox = () => {
    const portfolio = this.portfolioRef.current;

    if (portfolio) {
      portfolio.style.overflow = "";
      portfolio.scrollTop = this.portfolioScrollTop;
    }

    this.setState({ lightboxImage: null });

    document.body.style.overflow = "";
    document.body.classList.remove("lightbox-open");
  };

  handleKeyDown = (event) => {
    if (event.key === "Escape") {
      this.closeLightbox();
    }
  };

  playVideo = (index) => {
    this.videoPlayers.forEach((video) => {
      if (!video) return;

      video.pause();
      video.currentTime = 0;
    });

    this.setState({ playingVideo: index }, () => {
      const video = this.videoPlayers[index];

      if (!video) return;

      video.play().catch(() => {});
    });
  };

  stopVideo = () => {
    this.videoPlayers.forEach((video) => {
      if (!video) return;

      video.pause();
      video.currentTime = 0;
    });

    this.setState({ playingVideo: null });
  };

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentDidUpdate() {
    this.workBodies.forEach((body, index) => {
      if (!body) return;

      if (this.state.openProject === index) {
        body.style.maxHeight = body.scrollHeight + "px";
      } else {
        body.style.maxHeight = "0px";
      }
    });
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);

    document.body.style.overflow = "";
    document.body.classList.remove("lightbox-open");
  }

  render() {
    return (
      <article
        ref={this.portfolioRef}
        className="portfolio-panel"
        data-panel="portfolio"
      >
        <header className="panel-head">
          <h2 data-en="Portfolio" data-fa="نمونه‌کارها">
            Portfolio
          </h2>
          <span className="head-line"></span>
        </header>
        <div className="work-grid" id="workGrid">
          <div
            className={`work ${this.state.openProject === 0 ? "active" : ""}`}
          >
            <button
              className="work-head"
              aria-expanded={this.state.openProject === 0}
              onClick={() => this.toggleProject(0)}
            >
              <span className="work-head-text">
                <span
                  className="work-tag"
                  data-en="UI Design"
                  data-fa="طراحی UI"
                >
                  UI Design
                </span>
                <h4
                  data-en="Web & Ui Design"
                  data-fa="طراحی وب و رابط کاربری"
                >
                  Web & Ui Design
                </h4>
              </span>
              <span className="work-icon">+</span>
            </button>
            <div
              className="work-body"
              ref={(el) => {
                this.workBodies[0] = el;
              }}
            >
              <div className="work-body-inner">
                <div className="work-gallery">
                  <span className="thumb">
                    <img
                      src="/image/ui (1).png"
                      alt=""
                      onClick={() => this.openLightbox("/image/ui (1).png")}/>
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/ui (2).png"
                      alt=""
                      onClick={() => this.openLightbox("/image/ui (2).png")}/>
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/ui (3).png"
                      alt=""
                      onClick={() => this.openLightbox("/image/ui (3).png")}/>
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/ui (4).png"
                      alt=""
                      onClick={() => this.openLightbox("/image/ui (4).png")}/>
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/Image/ui (5).png"
                      alt=""
                      onClick={() => this.openLightbox("/Image/ui (5).png")}/>
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/Image/ui (6).png"
                      alt=""
                      onClick={() => this.openLightbox("/Image/ui (6).png")}/>
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/ui (7).png"
                      alt=""
                      onClick={() => this.openLightbox("/image/ui (7).png")}/>
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/ui-(8).png"
                      alt=""
                      onClick={() => this.openLightbox("/image/ui-(8).png")}/>
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/Image/ui (9) .png"
                      alt=""
                      onClick={() => this.openLightbox("/image/ui (9) .png")}/>
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/ui-(10)-.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/ui-(10)-.png")}/>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`work ${this.state.openProject === 1 ? "active" : ""}`}
          >
            <button
              className="work-head"
              aria-expanded={this.state.openProject === 1}
              onClick={() => this.toggleProject(1)}
            >
              <span className="work-head-text">
                <span className="work-tag" data-en="photo" data-fa="عکاسی">
                  photo
                </span>
                <h4 data-en="Photography" data-fa="عکاسی محصول و محتوایی">
                  Photography
                </h4>
              </span>
              <span className="work-icon">+</span>
            </button>
            <div
              className="work-body"
              ref={(el) => {
                this.workBodies[1] = el;
              }}
            >
              <div className="work-body-inner">
                <div className="work-gallery">
                  <span className="thumb">
                    
                    <img
                      src="/image/photography1.png"
                      alt=""
                      onClick={() =>
                        this.openLightbox("/image/photography1.png")
                      }
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/photography2.png"
                      alt=""
                      onClick={() =>
                        this.openLightbox("/image/photography2.png")
                      }
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/photography3.png"
                      alt=""
                      onClick={() =>
                        this.openLightbox("/image/photography3.png")
                      }
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/photography4.png"
                      alt=""
                      onClick={() =>
                        this.openLightbox("/image/photography4.png")
                      }
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/photography5.png"
                      alt=""
                      onClick={() =>
                        this.openLightbox("/image/photography5.png")
                      }
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/photography6.png"
                      alt=""
                      onClick={() =>
                        this.openLightbox("/image/photography6.png")
                      }
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/photography7.png"
                      alt=""
                      onClick={() =>
                        this.openLightbox("/image/photography7.png")
                      }
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`work ${this.state.openProject === 2 ? "active" : ""}`}
          >
            <button
              className="work-head"
              aria-expanded={this.state.openProject === 2}
              onClick={() => this.toggleProject(2)}
            >
              <span className="work-head-text">
                <span
                  className="work-tag"
                  data-en="Graphic"
                  data-fa="طراحی گرافیک"
                >
                  Graphic
                </span>
                <h4 data-en=" Graphic Design" data-fa="طراحی گرافیک">
                  Graphic Design
                </h4>
              </span>
              <span className="work-icon">+</span>
            </button>
            <div
              className="work-body"
              ref={(el) => {
                this.workBodies[2] = el;
              }}
            >
              <div className="work-body-inner">
                <div className="work-gallery">
                  <span className="thumb">
                    
                    <img
                      src="/image/graphic2.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/graphic2.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/graphic3.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/graphic3.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/graphic4.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/graphic4.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/graphic5.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/graphic5.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/graphic6.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/graphic6.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/graphic7.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/graphic7.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/graphic8.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/graphic8.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/graphic9.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/graphic9.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/graphic10.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/graphic10.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/graphic11.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/graphic11.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/graphic12.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/graphic12.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/graphic13.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/graphic13.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/graphic14.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/graphic14.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/graphic15.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/graphic15.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/graphic16.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/graphic16.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/graphic17.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/graphic17.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/graphic1.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/graphic1.png")}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`work ${this.state.openProject === 3 ? "active" : ""}`}
          >
            <button
              className="work-head"
              aria-expanded={this.state.openProject === 3}
              onClick={() => this.toggleProject(3)}
            >
              <span className="work-head-text">
                <span
                  className="work-tag"
                  data-en="Event"
                  data-fa="رویداد و اجرا"
                >
                  Mobile
                </span>
                <h4 data-en="Event & Experiences" data-fa="رویداد و اجرا">
                  Event & Experiences
                </h4>
              </span>
              <span className="work-icon">+</span>
            </button>
            <div
              className="work-body"
              ref={(el) => {
                this.workBodies[3] = el;
              }}
            >
              <div className="work-body-inner">
                <div className="work-gallery">
                  <span className="thumb">
                    
                    <img
                      src="/image/event2.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/event2.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/event3.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/event3.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/event4.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/event4.png")}
                    />
                  </span>
                  <span className="thumb">
                    
                    <img
                      src="/image/event1.png"
                      alt=""
                      onClick={() => this.openLightbox("/image/event1.png")}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`work work-video ${
              this.state.openProject === 4 ? "active" : ""
            }`}
          >
            <button
              className="work-head"
              aria-expanded={this.state.openProject === 4}
              onClick={() => this.toggleProject(4)}
            >
              <span className="work-head-text">
                <span
                  className="work-tag"
                  data-en="Video Editing"
                  data-fa="تدوین ویدیو"
                >
                  Video Editing
                </span>
                <h4 data-en="Video Reel" data-fa=" تدوین">
                  Video Reel
                </h4>
              </span>
              <span className="work-icon">+</span>
            </button>
            <div
              className="work-body"
              ref={(el) => {
                this.workBodies[4] = el;
              }}
            >
              <div className="work-body-inner">
                <div className="work-gallery">
                  <div
                    className={`video-showcase ${this.state.playingVideo === 0 ? "is-playing" : ""}`}
                    data-video-src="/video/emamzade.mp4"
                  >
                    <img
                      className="video-poster"
                      src="/video/cover1.png"
                      alt="Video editing showcase preview 1"
                    />
                    <button
                      className="video-play-btn"
                      type="button"
                      aria-label="Play video"
                      onClick={() => this.playVideo(0)}
                    >
                      <i className="bi bi-play-fill"></i>
                    </button>
                    <video
                      className="video-player"
                      controls
                      playsInline
                      preload="none"
                      src="/video/emamzade.mp4"
                      ref={(el) => {
                        this.videoPlayers[0] = el;
                      }}
                      onEnded={this.stopVideo}
                    ></video>
                    <a
                      className="video-download-btn"
                      href="/video-quality/video1.MP4"
                      download
                      target="_blank"
                      rel="noopener"
                      aria-label="Download HD video"
                    >
                      <i className="bi bi-download"></i>
                      <span
                        data-en="Download HD Video"
                        data-fa="دانلود ویدیو با کیفیت"
                      >
                        Download HD Video
                      </span>
                    </a>
                  </div>
                  <div
                    className={`video-showcase ${this.state.playingVideo === 1 ? "is-playing" : ""}`}
                    data-video-src="/video/zarabi1.mp4"
                  >
                    <img
                      className="video-poster"
                      src="/video/cover2.png"
                      alt="Video editing showcase preview 1"
                    />
                    <button
                      className="video-play-btn"
                      type="button"
                      aria-label="Play video"
                      onClick={() => this.playVideo(1)}
                    >
                      <i className="bi bi-play-fill"></i>
                    </button>
                    <video
                      className="video-player"
                      controls
                      playsInline
                      preload="none"
                      src="/video/zarabi1.mp4"
                      ref={(el) => {
                        this.videoPlayers[1] = el;
                      }}
                      onEnded={this.stopVideo}
                    ></video>
                    <a
                      className="video-download-btn"
                      href="/video-quality/video2.MP4"
                      download
                      target="_blank"
                      rel="noopener"
                      aria-label="Download HD video"
                    >
                      <i className="bi bi-download"></i>
                      <span
                        data-en="Download HD Video"
                        data-fa="دانلود ویدیو با کیفیت"
                      >
                        Download HD Video
                      </span>
                    </a>
                  </div>
                  <div
                    className={`video-showcase ${this.state.playingVideo === 2 ? "is-playing" : ""}`}
                    data-video-src="/video/ariana.mp4"
                  >
                    <img
                      className="video-poster"
                      src="/video/cover3.png"
                      alt="Video editing showcase preview 1"
                    />
                    <button
                      className="video-play-btn"
                      type="button"
                      aria-label="Play video"
                      onClick={() => this.playVideo(2)}
                    >
                      <i className="bi bi-play-fill"></i>
                    </button>
                    <video
                      className="video-player"
                      controls
                      playsInline
                      preload="none"
                      src="/video/ariana.mp4"
                      ref={(el) => {
                        this.videoPlayers[2] = el;
                      }}
                      onEnded={this.stopVideo}
                    ></video>
                    <a
                      className="video-download-btn"
                      href="/video-quality/video3.MP4"
                      download
                      target="_blank"
                      rel="noopener"
                      aria-label="Download HD video"
                    >
                      <i className="bi bi-download"></i>
                      <span
                        data-en="Download HD Video"
                        data-fa="دانلود ویدیو با کیفیت"
                      >
                        Download HD Video
                      </span>
                    </a>
                  </div>
                  <div
                    className={`video-showcase ${this.state.playingVideo === 3 ? "is-playing" : ""}`}
                    data-video-src="/video/zarabi2.mp4"
                  >
                    <img
                      className="video-poster"
                      src="/video/cover4.png"
                      alt="Video editing showcase preview 1"
                    />
                    <button
                      className="video-play-btn"
                      type="button"
                      aria-label="Play video"
                      onClick={() => this.playVideo(3)}
                    >
                      <i className="bi bi-play-fill"></i>
                    </button>
                    <video
                      className="video-player"
                      controls
                      playsInline
                      preload="none"
                      src="/video/zarabi2.mp4"
                      ref={(el) => {
                        this.videoPlayers[3] = el;
                      }}
                      onEnded={this.stopVideo}
                    ></video>
                    <a
                      className="video-download-btn"
                      href="/video-quality/video4.MP4"
                      download
                      target="_blank"
                      rel="noopener"
                      aria-label="Download HD video"
                    >
                      <i className="bi bi-download"></i>
                      <span
                        data-en="Download HD Video"
                        data-fa="دانلود ویدیو با کیفیت"
                      >
                        Download HD Video
                      </span>
                    </a>
                  </div>
                  <div
                    className={`video-showcase ${this.state.playingVideo === 4 ? "is-playing" : ""}`}
                    data-video-src="/video/emamzade2.mp4"
                  >
                    <img
                      className="video-poster"
                      src="/video/cover5.png"
                      alt="Video editing showcase preview 1"
                    />
                    <button
                      className="video-play-btn"
                      type="button"
                      aria-label="Play video"
                      onClick={() => this.playVideo(4)}
                    >
                      <i className="bi bi-play-fill"></i>
                    </button>
                    <video
                      className="video-player"
                      controls
                      playsInline
                      preload="none"
                      src="/video/emamzade2.mp4"
                      ref={(el) => {
                        this.videoPlayers[4] = el;
                      }}
                      onEnded={this.stopVideo}
                    ></video>
                    <a
                      className="video-download-btn"
                      href="/video-quality/video5.MP4"
                      download
                      target="_blank"
                      rel="noopener"
                      aria-label="Download HD video"
                    >
                      <i className="bi bi-download"></i>
                      <span
                        data-en="Download HD Video"
                        data-fa="دانلود ویدیو با کیفیت"
                      >
                        Download HD Video
                      </span>
                    </a>
                  </div>
                  <div
                    className={`video-showcase ${this.state.playingVideo === 5 ? "is-playing" : ""}`}
                    data-video-src="/video/ariana event.mp4"
                  >
                    <img
                      className="video-poster"
                      src="/video/cover6.png"
                      alt="Video editing showcase preview 1"
                    />
                    <button
                      className="video-play-btn"
                      type="button"
                      aria-label="Play video"
                      onClick={() => this.playVideo(5)}
                    >
                      <i className="bi bi-play-fill"></i>
                    </button>
                    <video
                      className="video-player"
                      controls
                      playsInline
                      preload="none"
                      src="/video/ariana event.mp4"
                      ref={(el) => {
                        this.videoPlayers[5] = el;
                      }}
                      onEnded={this.stopVideo}
                    ></video>
                    <a
                      className="video-download-btn"
                      href="/video-quality/video6.MP4"
                      download
                      target="_blank"
                      rel="noopener"
                      aria-label="Download HD video"
                    >
                      <i className="bi bi-download"></i>
                      <span
                        data-en="Download HD Video"
                        data-fa="دانلود ویدیو با کیفیت"
                      >
                        Download HD Video
                      </span>
                    </a>
                  </div>
                  <div
                    className={`video-showcase ${this.state.playingVideo === 6 ? "is-playing" : ""}`}
                    data-video-src="/video/javaher.mp4"
                  >
                    <img
                      className="video-poster"
                      src="/video/cover7.png"
                      alt="Video editing showcase preview 1"
                    />
                    <button
                      className="video-play-btn"
                      type="button"
                      aria-label="Play video"
                      onClick={() => this.playVideo(6)}
                    >
                      <i className="bi bi-play-fill"></i>
                    </button>
                    <video
                      className="video-player"
                      controls
                      playsInline
                      preload="none"
                      src="/video/javaher.mp4"
                      ref={(el) => {
                        this.videoPlayers[6] = el;
                      }}
                      onEnded={this.stopVideo}
                    ></video>
                    <a
                      className="video-download-btn"
                      href="/video-quality/video7.MP4"
                      download
                      target="_blank"
                      rel="noopener"
                      aria-label="Download HD video"
                    >
                      <i className="bi bi-download"></i>
                      <span
                        data-en="Download HD Video"
                        data-fa="دانلود ویدیو با کیفیت"
                      >
                        Download HD Video
                      </span>
                    </a>
                  </div>
                  <div
                    className={`video-showcase ${this.state.playingVideo === 7 ? "is-playing" : ""}`}
                    data-video-src="/video/kebria1.mp4"
                  >
                    <img
                      className="video-poster"
                      src="/video/cover8.png"
                      alt="Video editing showcase preview 1"
                    />
                    <button
                      className="video-play-btn"
                      type="button"
                      aria-label="Play video"
                      onClick={() => this.playVideo(7)}
                    >
                      <i className="bi bi-play-fill"></i>
                    </button>
                    <video
                      className="video-player"
                      controls
                      playsInline
                      preload="none"
                      src="/video/kebria1.mp4"
                      ref={(el) => {
                        this.videoPlayers[7] = el;
                      }}
                      onEnded={this.stopVideo}
                    ></video>
                    <a
                      className="video-download-btn"
                      href="/video-quality/video8.MP4"
                      download
                      target="_blank"
                      rel="noopener"
                      aria-label="Download HD video"
                    >
                      <i className="bi bi-download"></i>
                      <span
                        data-en="Download HD Video"
                        data-fa="دانلود ویدیو با کیفیت"
                      >
                        Download HD Video
                      </span>
                    </a>
                  </div>
                  <div
                    className={`video-showcase ${this.state.playingVideo === 8 ? "is-playing" : ""}`}
                    data-video-src="/video/Emamzade3.mp4"
                  >
                    <img
                      className="video-poster"
                      src="/video/cover9.png"
                      alt="Video editing showcase preview 1"
                    />
                    <button
                      className="video-play-btn"
                      type="button"
                      aria-label="Play video"
                      onClick={() => this.playVideo(8)}
                    >
                      <i className="bi bi-play-fill"></i>
                    </button>
                    <video
                      className="video-player"
                      controls
                      playsInline
                      preload="none"
                      src="/video/Emamzade3.mp4"
                      ref={(el) => {
                        this.videoPlayers[8] = el;
                      }}
                      onEnded={this.stopVideo}
                    ></video>
                    <a
                      className="video-download-btn"
                      href="/video-quality/video9.MP4"
                      download
                      target="_blank"
                      rel="noopener"
                      aria-label="Download HD video"
                    >
                      <i className="bi bi-download"></i>
                      <span
                        data-en="Download HD Video"
                        data-fa="دانلود ویدیو با کیفیت"
                      >
                        Download HD Video
                      </span>
                    </a>
                  </div>
                  <div
                    className={`video-showcase ${this.state.playingVideo === 9 ? "is-playing" : ""}`}
                    data-video-src="/video/helen.mp4"
                  >
                    <img
                      className="video-poster"
                      src="/video/cover10.png"
                      alt="Video editing showcase preview 1"
                    />
                    <button
                      className="video-play-btn"
                      type="button"
                      aria-label="Play video"
                      onClick={() => this.playVideo(9)}
                    >
                      <i className="bi bi-play-fill"></i>
                    </button>
                    <video
                      className="video-player"
                      controls
                      playsInline
                      preload="none"
                      src="/video/helen.mp4"
                      ref={(el) => {
                        this.videoPlayers[9] = el;
                      }}
                      onEnded={this.stopVideo}
                    ></video>
                    <a
                      className="video-download-btn"
                      href="/video-quality/video10.MP4"
                      download
                      target="_blank"
                      rel="noopener"
                      aria-label="Download HD video"
                    >
                      <i className="bi bi-download"></i>
                      <span
                        data-en="Download HD Video"
                        data-fa="دانلود ویدیو با کیفیت"
                      >
                        Download HD Video
                      </span>
                    </a>
                  </div>
                  <div
                    className={`video-showcase ${this.state.playingVideo === 10 ? "is-playing" : ""}`}
                    data-video-src="/video/kebria2.mp4"
                  >
                    <img
                      className="video-poster"
                      src="/video/cover11.png"
                      alt="Video editing showcase preview 1"
                    />
                    <button
                      className="video-play-btn"
                      type="button"
                      aria-label="Play video"
                      onClick={() => this.playVideo(10)}
                    >
                      <i className="bi bi-play-fill"></i>
                    </button>
                    <video
                      className="video-player"
                      controls
                      playsInline
                      preload="none"
                      src="/video/kebria2.mp4"
                      ref={(el) => {
                        this.videoPlayers[10] = el;
                      }}
                      onEnded={this.stopVideo}
                    ></video>
                    <a
                      className="video-download-btn"
                      href="/video-quality/video11.MP4"
                      download
                      target="_blank"
                      rel="noopener"
                      aria-label="Download HD video"
                    >
                      <i className="bi bi-download"></i>
                      <span
                        data-en="Download HD Video"
                        data-fa="دانلود ویدیو با کیفیت"
                      >
                        Download HD Video
                      </span>
                    </a>
                  </div>
                  <div
                    className={`video-showcase ${this.state.playingVideo === 11 ? "is-playing" : ""}`}
                    data-video-src="/video/zarabi3.mp4"
                  >
                    <img
                      className="video-poster"
                      src="/video/cover12.png"
                      alt="Video editing showcase preview 1"
                    />
                    <button
                      className="video-play-btn"
                      type="button"
                      aria-label="Play video"
                      onClick={() => this.playVideo(11)}
                    >
                      <i className="bi bi-play-fill"></i>
                    </button>
                    <video
                      className="video-player"
                      controls
                      playsInline
                      preload="none"
                      src="/video/zarabi3.mp4"
                      ref={(el) => {
                        this.videoPlayers[11] = el;
                      }}
                      onEnded={this.stopVideo}
                    ></video>
                    <a
                      className="video-download-btn"
                      href="/video-quality/video12.MP4"
                      download
                      target="_blank"
                      rel="noopener"
                      aria-label="Download HD video"
                    >
                      <i className="bi bi-download"></i>
                      <span
                        data-en="Download HD Video"
                        data-fa="دانلود ویدیو با کیفیت"
                      >
                        Download HD Video
                      </span>
                    </a>
                  </div>
                  <div
                    className={`video-showcase ${this.state.playingVideo === 12 ? "is-playing" : ""}`}
                    data-video-src="/video/ariana event2.mp4"
                  >
                    <img
                      className="video-poster"
                      src="/video/cover13.png"
                      alt="Video editing showcase preview 1"
                    />
                    <button
                      className="video-play-btn"
                      type="button"
                      aria-label="Play video"
                      onClick={() => this.playVideo(12)}
                    >
                      <i className="bi bi-play-fill"></i>
                    </button>
                    <video
                      className="video-player"
                      controls
                      playsInline
                      preload="none"
                      src="/video/ariana event2.mp4"
                      ref={(el) => {
                        this.videoPlayers[12] = el;
                      }}
                      onEnded={this.stopVideo}
                    ></video>
                    <a
                      className="video-download-btn"
                      href="/video-quality/video13.MP4"
                      download
                      target="_blank"
                      rel="noopener"
                      aria-label="Download HD video"
                    >
                      <i className="bi bi-download"></i>
                      <span
                        data-en="Download HD Video"
                        data-fa="دانلود ویدیو با کیفیت"
                      >
                        Download HD Video
                      </span>
                    </a>
                  </div>
                  <div
                    className={`video-showcase ${this.state.playingVideo === 13 ? "is-playing" : ""}`}
                    data-video-src="/video/nemayeshgah.mp4"
                  >
                    <img
                      className="video-poster"
                      src="/video/cover14.png"
                      alt="Video editing showcase preview 1"
                    />
                    <button
                      className="video-play-btn"
                      type="button"
                      aria-label="Play video"
                      onClick={() => this.playVideo(13)}
                    >
                      <i className="bi bi-play-fill"></i>
                    </button>
                    <video
                      className="video-player"
                      controls
                      playsInline
                      preload="none"
                      src="/video/nemayeshgah.mp4"
                      ref={(el) => {
                        this.videoPlayers[13] = el;
                      }}
                      onEnded={this.stopVideo}
                    ></video>
                    <a
                      className="video-download-btn"
                      href="/video-quality/video14.MP4"
                      download
                      target="_blank"
                      rel="noopener"
                      aria-label="Download HD video"
                    >
                      <i className="bi bi-download"></i>
                      <span
                        data-en="Download HD Video"
                        data-fa="دانلود ویدیو با کیفیت"
                      >
                        Download HD Video
                      </span>
                    </a>
                  </div>
                  <div
                    className={`video-showcase ${this.state.playingVideo === 14 ? "is-playing" : ""}`}
                    data-video-src="/video/mehriran.mp4"
                  >
                    <img
                      className="video-poster"
                      src="/video/cover15.png"
                      alt="Video editing showcase preview 1"
                    />
                    <button
                      className="video-play-btn"
                      type="button"
                      aria-label="Play video"
                      onClick={() => this.playVideo(14)}
                    >
                      <i className="bi bi-play-fill"></i>
                    </button>
                    <video
                      className="video-player"
                      controls
                      playsInline
                      preload="none"
                      src="/video/mehriran.mp4"
                      ref={(el) => {
                        this.videoPlayers[14] = el;
                      }}
                      onEnded={this.stopVideo}
                    ></video>
                    <a
                      className="video-download-btn"
                      href="/video-quality/video15.MP4"
                      download
                      target="_blank"
                      rel="noopener"
                      aria-label="Download HD video"
                    >
                      <i className="bi bi-download"></i>
                      <span
                        data-en="Download HD Video"
                        data-fa="دانلود ویدیو با کیفیت"
                      >
                        Download HD Video
                      </span>
                    </a>
                  </div>
                  <div
                    className={`video-showcase ${this.state.playingVideo === 15 ? "is-playing" : ""}`}
                    data-video-src="/video/kebria3.mp4"
                  >
                    <img
                      className="video-poster"
                      src="/video/cover16.png"
                      alt="Video editing showcase preview 1"
                    />
                    <button
                      className="video-play-btn"
                      type="button"
                      aria-label="Play video"
                      onClick={() => this.playVideo(15)}
                    >
                      <i className="bi bi-play-fill"></i>
                    </button>
                    <video
                      className="video-player"
                      controls
                      playsInline
                      preload="none"
                      src="/video/kebria3.mp4"
                      ref={(el) => {
                        this.videoPlayers[15] = el;
                      }}
                      onEnded={this.stopVideo}
                    ></video>
                    <a
                      className="video-download-btn"
                      href="/video-quality/video16.MP4"
                      download
                      target="_blank"
                      rel="noopener"
                      aria-label="Download HD video"
                    >
                      <i className="bi bi-download"></i>
                      <span
                        data-en="Download HD Video"
                        data-fa="دانلود ویدیو با کیفیت"
                      >
                        Download HD Video
                      </span>
                    </a>
                  </div>
                  <div
                    className={`video-showcase ${this.state.playingVideo === 16 ? "is-playing" : ""}`}
                    data-video-src="/video/shalvar.mp4"
                  >
                    <img
                      className="video-poster"
                      src="/video/cover17.png"
                      alt="Video editing showcase preview 1"
                    />
                    <button
                      className="video-play-btn"
                      type="button"
                      aria-label="Play video"
                      onClick={() => this.playVideo(16)}
                    >
                      <i className="bi bi-play-fill"></i>
                    </button>
                    <video
                      className="video-player"
                      controls
                      playsInline
                      preload="none"
                      src="/video/shalvar.mp4"
                      ref={(el) => {
                        this.videoPlayers[16] = el;
                      }}
                      onEnded={this.stopVideo}
                    ></video>
                    <a
                      className="video-download-btn"
                      href="/video-quality/video17.MP4"
                      download
                      target="_blank"
                      rel="noopener"
                      aria-label="Download HD video"
                    >
                      <i className="bi bi-download"></i>
                      <span
                        data-en="Download HD Video"
                        data-fa="دانلود ویدیو با کیفیت"
                      >
                        Download HD Video
                      </span>
                    </a>
                  </div>
                  <div
                    className={`video-showcase ${this.state.playingVideo === 17 ? "is-playing" : ""}`}
                    data-video-src="/video/squt2.mp4"
                  >
                    <img
                      className="video-poster"
                      src="/video/cover18.png"
                      alt="Video editing showcase preview 1"
                    />
                    <button
                      className="video-play-btn"
                      type="button"
                      aria-label="Play video"
                      onClick={() => this.playVideo(17)}
                    >
                      <i className="bi bi-play-fill"></i>
                    </button>
                    <video
                      className="video-player"
                      controls
                      playsInline
                      preload="none"
                      src="/video/squt2.mp4"
                      ref={(el) => {
                        this.videoPlayers[17] = el;
                      }}
                      onEnded={this.stopVideo}
                    ></video>
                    <a
                      className="video-download-btn"
                      href="/video-quality/video18.mp4"
                      download
                      target="_blank"
                      rel="noopener"
                      aria-label="Download HD video"
                    >
                      <i className="bi bi-download"></i>
                      <span
                        data-en="Download HD Video"
                        data-fa="دانلود ویدیو با کیفیت"
                      >
                        Download HD Video
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {this.state.lightboxImage &&
          createPortal(
            <div
              className="lightbox"
              onClick={this.closeLightbox}
              role="dialog"
              aria-modal="true"
              aria-label="Image preview"
            >
              <button
                className="lightbox-close"
                type="button"
                onClick={this.closeLightbox}
                aria-label="Close image"
              >
                <i className="bi bi-x-lg"></i>
              </button>

              <img
                className="lightbox-image"
                src={this.state.lightboxImage}
                alt=""
                onClick={(e) => e.stopPropagation()}
              />
            </div>,
            document.body,
          )}
      </article>
    );
  }
}

export default Portfolio;
